import type { FC } from 'react';
import { useRelatedCategories } from '../../../bff-api/products/useRelatedCategories';
import { ProductsRelatedCategories } from '../../../components/products-related-categories/ProductsRelatedCategories';
import { usePDP } from '../../../contexts/pdp/usePDP';
import { useCustomPreferenceOrDefault } from '../../../utils/api';
import { CustomPreference } from '../../../utils/api/CustomPreference';

interface ProductRelatedCategoriesProps {
    className?: string;
}

export const ProductRelatedCategories: FC<ProductRelatedCategoriesProps> = ({ className }) => {
    const isEnabled = useCustomPreferenceOrDefault(
        CustomPreference.ENABLE_RELATED_CATEGORIES_ON_PDP,
        true,
    );
    const { product } = usePDP();

    const { data = [] } = useRelatedCategories(isEnabled && product ? product.id : '');

    if (!isEnabled || !data.length) {
        return null;
    }

    return <ProductsRelatedCategories data={data} className={className} />;
};

ProductRelatedCategories.defaultProps = {
    className: undefined,
};
